import React from 'react';
import RouteLink, { RouteLinkType } from '../../components/CustomRoutes/RouteLink';
import './NotFound.scss';

const NotFound: React.FC = () => {
    return (
        <div className="notFound">
            <h1 className="ms-fontColor-orangeLighter">404 - Page not found</h1>
            <RouteLink to="/" linkType={RouteLinkType.Link}>
                Back to home
            </RouteLink>
        </div>
    );
};

export default NotFound;
